import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";


// pages
const Home = React.lazy(() => import("./pages/Home"));
const About = React.lazy(() => import("./pages/About"));
const Charity = React.lazy(() => import("./pages/Charity"));
const NFTs = React.lazy(() => import("./pages/NFTs"));
const Socials = React.lazy(() => import("./pages/Socials"));

// import NotFound from "./pages/NotFound";

const App = () => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3>Loading...</h3>
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/charity" element={<Charity />} />
        <Route path="/nfts" element={<NFTs />} />
        <Route path="/socials" element={<Socials />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Suspense>
  );
};

export default App;
